"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function determineDeliveryMethod(deliveryMedium) {
    var codeDeliveryMethod = "unknown";
    switch (deliveryMedium.toUpperCase()) {
        case "EMAIL":
            codeDeliveryMethod = "email";
            break;
        case "SMS":
            codeDeliveryMethod = "sms";
            break;
    }
    return codeDeliveryMethod;
}
exports.determineDeliveryMethod = determineDeliveryMethod;
